import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { useActions } from '@mssgme/hooks';

export default function LogoutPage() {
    const actions = useActions();

    useEffect(() => {
        actions.api.auth.logout();
    }, []);

    return <Redirect to="login" />;
}
